import styled from "styled-components";
import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  MARGIN,
  SIZE,
} from "constants/variables";
import { ReactComponent as WhiteOpenFolderIcon } from "assets/svg/WhiteOpenFolderIcon.svg";

export const ProjectsSectionContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${SIZE.max24};
`;

export const RedContainer = styled.div`
  background-color: ${COLORS.Crimson};
  border-radius: ${BORDER_RADIUS.radius24};
  position: relative;
  overflow: hidden;
  margin: ${SIZE.max120} 0;
  height: auto;
  width: 65%;

  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 80%;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    width: 100%;
  }
`;

export const ProjectsSectionWrapper = styled.div`
  height: auto;
  z-index: 5;
  position: relative;
  display: flex;
`;

export const CirclesWrapper = styled.div`
  z-index: 0;
`;

export const ProjectsSectionDescriptionContainer = styled.div`
  padding: ${SIZE.max65} ${SIZE.max80};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: ${SIZE.max24};
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
